import { ProfileOGData } from '~/util/types/og';
import { ProfileMerged } from '~/util/types/profiles';

export const createOGProfileData = (profile: ProfileMerged): ProfileOGData => {
    const user = {
        id: profile.id,
        username: profile.username,
        global_name: profile.global_name,
        description: profile.description,
        country: profile.country,
        discord_id: profile.discord_id,
        discord_avatar: profile.discord_avatar,
    };

    const topCompletedLevels =
        profile.records
            ?.filter(
                (record) =>
                    record.level.status == 'MainList' ||
                    record.level.status == 'Pending',
            )
            .sort(
                (a, b) =>
                    (a.level.position ?? Infinity) -
                    (b.level.position ?? Infinity),
            )
            .slice(0, 4)
            .map((record) => record.level) ?? [];

    return {
        user,
        topCompletedLevels,
        clanTag: profile?.clan?.tag || undefined,
        globalRank: profile?.rank?.rank || undefined,
        countryRank: profile?.rank?.country_rank || undefined,
        completedExtremesCount: profile?.rank?.extremes || undefined,
        createdCount: profile?.created.length || undefined,
        packsCount: profile?.packs.length || undefined,
    };
};
